export default __webpack_public_path__ + "static/4-9132e59b1307ebaaeb935b3867741b9c.mp4";